/** Words with more than 3 letters are uppercased (Estado/Motivo de devolución). */
export function formatReturnOptionLabel(option: string): string {
  return option
    .split(/(\s+)/)
    .map((segment) => {
      if (/^\s+$/.test(segment)) {
        return segment;
      }
      return segment
        .split('-')
        .map((word) => (word.length > 3 ? word.toUpperCase() : word))
        .join('-');
    })
    .join('');
}

const RETURN_STATUS_RAW = [
  'sin compra',
  'Devolución aceptada',
  'Enviado al proveedor',
  'stock clavo',
  'stock clavo por vencimiento ML',
  'Reclamo DAC - Aprobado',
  'Reclamo DAC - en Proceso',
  'Reclamo DAC - Denegado'
] as const;

/** Textos exactos del cliente (sin formateo). */
const RETURN_STATUS_EXTRA = [
  'En consulta con proveedor',
  'Recuperando Orden',
  'Tratativa Transp. BR',
  'Abrir Devolución ML'
] as const;

const RETURN_REASON_RAW = [
  'averia',
  'Incompatibilidad Cotizacion',
  'Incompatibilidad Proveedor',
  'no repara',
  'atraso',
  'otros'
] as const;

export const RETURN_LOG_STATUS_OPTIONS: string[] = [
  'en taller',
  'en local BR',
  'enviado',
  'cobrado',
  'en local UY'
];

export const RETURN_CARRIER_OPTIONS: string[] = [
  'EXP SÃO MIGUEL',
  'VIOPEX',
  'RODONAVES',
  'FRETE CARWAY/DIJON',
  'CORREIOS',
  'TRANSP 1',
  'TRANSP 2'
];

export const ML_STATUS_OPTIONS: string[] = [
  'AGUARDANDO RESPUESTA',
  'ACEPTADO',
  'NO ACEPTADO',
  'AGUARDANDO COLETA',
  'ENVIAR CORREIOS'
];

export const FRETE_DEV_OPTIONS: string[] = [
  'MAV',
  'Proveedor'
];

export const RETURN_STATUS_OPTIONS: string[] = [
  ...RETURN_STATUS_RAW.map(formatReturnOptionLabel),
  ...RETURN_STATUS_EXTRA
];

export const RETURN_REASON_OPTIONS: string[] = RETURN_REASON_RAW.map(formatReturnOptionLabel);
